import { mutatorAction } from 'satcheljs';
import { store } from '../store/store';

const setCurrentThemeMutator: (normalizedThemeId: string) => void = mutatorAction(
    'SET_CURRENT_THEME',
    (normalizedThemeId: string): void => {
        store().theme = normalizedThemeId;
    }
);
export default setCurrentThemeMutator;
